import { gql } from '@apollo/client';

export const SUBMIT_SUPPORT_REQUEST = gql`
  mutation SubmitSupportRequest($input: SubmitSupportRequestInput!) {
    submitSupportRequest(input: $input) {
      requestId
      message
    }
  }
`;
